import { GetClaimsFilter } from "../../../interfaces/services/claim";
import { PolicyOverdueDebtFilters, PolicyOverdueDebtListResponse } from "../../../interfaces/services/policy-overdue-debt-service";
import { getError, getUserInfo } from "../../../utils";
import CustomHttpClient from "../../customHttpClient";

const customHttpClient = CustomHttpClient({ baseUrl: 'productores' });

const PolicyOverdueDebtService = {
  async getPolicyOverdueDebt(type: string): Promise<PolicyOverdueDebtListResponse> {
        const url = 'polizasConDeudaVencida';
        const params = { ...getUserInfo(), 'tipo':type };

        try {
            const response = await customHttpClient.get(url, { params });
    
            return response.data;
        } catch (error) {
            throw new Error(getError(error));
        }

  }
}

export default PolicyOverdueDebtService;